import departmentCommitTypes from './commit-types';
import ApiService from '../../../shared/services/api-service';
import commonActionCreators from '../../../shared/store/common/action-creators';

const departmentActionCreators = {
  fetchDepartmentForms() {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchDepartmentForms'));
      const data = await ApiService.get('/api/v1/departments/forms')
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.resolve();
        });
      dispatch(this.setIsLoading('fetchDepartmentForms'));
      if (data) {
        dispatch(this.fetchDepartmentFormsSuccess(data));
      }
      return Promise.resolve();
    };
  },
  fetchDepartmentFormsSuccess(departmentFormsResponse) {
    return {
      forms: departmentFormsResponse.data,
      type: departmentCommitTypes.PUSH_DEPARTMENT_FORMS,
    };
  },
  resetDepartmentState() {
    return {
      type: departmentCommitTypes.RESET_DEPARTMENT_STATE,
    };
  },
  setFormFor(formFor) {
    return {
      formFor,
      type: departmentCommitTypes.SET_FORM_FOR,
    };
  },
  setIsLoading(isLoading) {
    return {
      isLoading,
      type: departmentCommitTypes.SET_DEPARTMENT_IS_LOADING,
    };
  },
};

export default departmentActionCreators;
